import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import GroupSubNav from "../../components/layout/GroupSubNav";
import HeaderNavigation from "../../components/layout/HeaderNavigation";
import { getBlogsApi } from "../../store/actions";
import { scrollToTop } from "../../utils/scrollToTop";
import BlogArticles from "./components/BlogArticles";
import BlogFeatured from "./components/BlogFeatured";
import BlogHeader from "./components/BlogHeader";
import BlogNewsletter from "./components/BlogNewsletter";
import BlogQuickFilter from "./components/BlogQuickFilter";
import SiteFooter from "../../components/layout/SiteFooter";

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = async (params) => {
    setLoading(true);
    try {
      const response = await getBlogsApi(params);
      setBlogs(response.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    scrollToTop();
    const params = {
      page: 1,
      limit: 100,
    };
    fetchData(params);
  }, []);

  const handleFetchCategoryData = async (category) => {
    const params = {
      page: 1,
      limit: 100,
      category,
    };
    await fetchData(params);
  };

  const handleSearch = async (e, search) => {
    e.preventDefault();

    if (e.keyCode === 13) {
      const params = {
        page: 1,
        limit: 100,
        search,
      };

      await fetchData(params);
    }
  };

  return (
    <div>
      <Helmet>
        <title>Utiva | Blog</title>
        <meta
          name="description"
          content="Read the latest insights, news, and stories from the Utiva community."
        />
        <meta property="og:title" content="Utiva | Blog" />
        <meta
          property="og:description"
          content="Read the latest insights, news, and stories from the Utiva community."
        />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
      </Helmet>

      <header className="w-full relative">
        <HeaderNavigation />
      </header>
      <GroupSubNav />

      <main>
        <BlogHeader handleSearch={handleSearch} />

        {!loading && <BlogFeatured blog={blogs?.[0]} />}

        <section
          id="journal"
          aria-labelledby="journal-title"
          className="mx-auto px-4 pt-[42px] pb-[65px] lg:px-[26px] lg:pt-[52px] lg:pb-[90px]"
          style={{ maxWidth: "1280px", scrollMarginTop: "95px" }}
        >
          <BlogQuickFilter
            handleFetchCategoryData={handleFetchCategoryData}
            count={blogs?.length || 0}
          />

          <BlogArticles loading={loading} blogs={blogs} />
        </section>

        <BlogNewsletter />
      </main>
      <SiteFooter />
    </div>
  );
};

export default Blog;
